/* eslint-disable max-lines */
/* eslint-disable no-shadow */
import {
  call, join, put, take, takeEvery 
} from "redux-saga/effects";
import { getId, injectApiWithContextFactory, injectBoundActionCreatorsFactory, takeLatestByScope } from "Utils/sagaUtils";
import noop from "lodash.noop";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import {
  closeV2HeadingDialog, getSubHeadingIDs, loadCurrentUser, loadHeadingWorkflow, saveHeadingWorkflow,v2ReadHeading 
} from "./headingWorkflow.api";
import { v2WorkflowActionResult } from "../workflowWidget/workflowWidget.api";
import {
  LOAD_HEADING_WORKFLOW_CURRENTUSER_REQUESTED,
  LOAD_HEADING_WORKFLOW_REQUESTED,
  SAVE_HEADING_WORKFLOW_REQUESTED,
  failLoadHeadingWorkflow,
  failSaveHeadingWorkflow,
  successLoadCurrentUser,
  successLoadHeadingWorkflow,
  successSaveHeadingWorkflow
    
} from "./headingWorkflow.duck";

export const withBoundActions = injectBoundActionCreatorsFactory(
  {
    successSaveHeadingWorkflow,
    failSaveHeadingWorkflow,
    failLoadHeadingWorkflow,
    successLoadHeadingWorkflow,
    successLoadCurrentUser,
  },
  getId
);

export const withApiContext = injectApiWithContextFactory(
  {
    saveHeadingWorkflow,
    getSubHeadingIDs,
    loadHeadingWorkflow,
    v2ReadHeading,
    closeV2HeadingDialog,
    loadCurrentUser,
    v2WorkflowActionResult
  },
  injectBoundGQLClient
);

function* saveHeadingWorkflowSaga({
  data: { headingWorkflowId, isApplyToAllSubheadings = false, ownerId, v2Context },
  api: { saveHeadingWorkflow, v2ReadHeading, closeV2HeadingDialog, v2WorkflowActionResult = noop },
  actions: { successSaveHeadingWorkflow = noop, failSaveHeadingWorkflow = noop },
  mdContext = {},
  resolve = noop,
  reject = noop
}) {
  try {
    const { heading, document, project } = v2Context || mdContext;
    const v3ProjectId = project;
    const v2DocumentId = document.split("-").pop();
    const v2HeadingId = heading;
    
    const result = yield saveHeadingWorkflow({ v3ProjectId, v2DocumentId, v2HeadingId, headingOwnerId: ownerId });

    if (isApplyToAllSubheadings) {
      const subheadingIds = yield v2ReadHeading({ headingId: heading });
      for (let i = 0; i <= subheadingIds.length - 1; i++) {
        yield saveHeadingWorkflow({ v3ProjectId, v2DocumentId, v2HeadingId: subheadingIds[i], headingOwnerId: ownerId });
      }
    }

    yield successSaveHeadingWorkflow(result);
    yield closeV2HeadingDialog();
    yield v2WorkflowActionResult({ actionResult: { documentId: v2DocumentId, headingIds: [v2HeadingId], success: true } });
    yield call(resolve);
  } catch (error) {
    console.error(error);
    yield v2WorkflowActionResult({ actionResult: { success: false, message: error } });
    yield failSaveHeadingWorkflow(error);
    yield call(reject, error);
  }
}

function* loadHeadingWorkflowSaga({
  data,
  api: { loadHeadingWorkflow = noop },
  actions: { failLoadHeadingWorkflow = noop, successLoadHeadingWorkflow = noop },
  mdContext,
  resolve = noop,
  reject = noop,
}) {
  try {
    const { heading, document, project } = mdContext;
    const v2HeadingId = heading;
    const v2DocumentId = document.split("-").pop();
    const v3ProjectId = project;
    const params = { v3ProjectId, v2DocumentId, v2HeadingId };

    const result = yield loadHeadingWorkflow(params);
    yield successLoadHeadingWorkflow(result);
    yield call(resolve);
  } catch (error) {
    yield failLoadHeadingWorkflow(error);
    yield call(reject, error);
  }
}

function* loadCurrentUserSaga({
  data,
  api: { loadCurrentUser = noop },
  actions: { successLoadCurrentUser=noop  },
  mdContext,
  resolve = noop,
  reject = noop,
}) {
  try {
    const params = {  };

    const result = yield loadCurrentUser(params);  
    yield successLoadCurrentUser(result);
    yield call(resolve);
  } catch (error) {
    yield call(reject, error);
  }
} 
export default () =>
  function* rootSaga() {
    yield takeEvery(SAVE_HEADING_WORKFLOW_REQUESTED, withApiContext(withBoundActions(saveHeadingWorkflowSaga)));
    yield takeLatestByScope(LOAD_HEADING_WORKFLOW_REQUESTED, withApiContext(withBoundActions(loadHeadingWorkflowSaga)));

    yield takeLatestByScope(LOAD_HEADING_WORKFLOW_CURRENTUSER_REQUESTED, withApiContext(withBoundActions(loadCurrentUserSaga)));
  };
